export const TEMPLATE_ROW_SM = 72;

export const TEMPLATE_ROW_LG = 96;

export const TEMPLATE_TYPES_LABEL = {
  getMyTemplates: 'template',
  getViboTemplates: 'publicTemplates',
  getCompanyTemplates: 'companyTemplates',
};
